import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';

import { initialFields } from '../constants/OrganizationModal';

type Props = {
  fields: typeof initialFields;
};

export const useSetTouched = ({ fields }: Props) => {
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    if (!isEqual(initialFields, fields)) {
      setIsTouched(true);
    } else {
      setIsTouched(false);
    }
  }, [fields]);

  return {
    isTouched,
  };
};
